import React from "react";
import useHourlySchedule from "./useHourlySchedule";
import { Grid, Paper } from "@mui/material";
import "./style.scss";
import SingleDateSelector from "../shared/SingleDateSelector/SingleDateSelector";
import LoadableComponent from "../../../features/Loading/LoadableComponent";
import HourlyScheduleTable from "./Table/HourlyScheduleTable";

const HourlySchedule: React.FC = () => {
  const { loading, data, selectedDate, setSelectedDate, dataMessage } = useHourlySchedule();

  return (
    <div className="hourly-schedule-container" id="nawigacja-testowa">
      <Grid container spacing={2} alignItems={"center"}>
        <Grid item xs={8}>
          <div className="hourly-schedule-title">Kalendarz wydarzeń</div>
        </Grid>
        <Grid container item xs={4} justifyContent="flex-end">
          <SingleDateSelector selectedDate={selectedDate} setSelectedDate={setSelectedDate} />
        </Grid>

        <Grid item xs={12}>
          <Paper sx={{ p: 2 }}>
            <LoadableComponent loading={loading}>
              {!dataMessage ? (
                <HourlyScheduleTable data={data} selectedDate={selectedDate} />
              ) : (
                <span style={{ fontSize: "13px" }}>{dataMessage}</span>
              )}
            </LoadableComponent>
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
};

export default HourlySchedule;
